{
	"g": {
		"vms": "VMS PRO",
		"creation_date": "Creation Date",
		"actions": "Actions",
		"number": "No.",
		"no_results_found": "No results found",
		"total_items": "Total Items",
		"items_per_page": "Items per page",
		"edit": "Edit",
		"delete": "Delete",
		"search": "Search",
		"reset": "Reset",
		"save": "Save",
		"cancel": "Cancel",
		"run": "Run",
		"unauthorized_access": "Unauthorized Access",
		"unauthorized_user": "Unauthorized User",
		"global_success_msg": "Operation done successfully!",
		"global_err": "An error occurred!",
		"global_auth_err": "Unauthorized access!",
		"request_timed_out": "Your request has timed out!",
		"invalid_captcha": "Invalid captcha!",
		"invalid_input": "Invalid input!",
		"search_by": "Search by",
		"search_for": "Search for",
		"is_partial": "Is Partial",
		"read": "Read",
		"write": "Write",
		"add": "Add",
		"yes": "Yes",
		"no": "No",
		"welcome": "Welcome",
		"submit": "Submit",
		"settings": "Settings",
		"back": "Back",
		"latitude": "Latitude",
		"longitude": "Longitude",
		"high": "High",
		"low": "Low",
		"ok": "OK",
		"invalid_fields": "Invalid fields",
		"upload": "Upload",
		"start_date": "Start Date",
		"end_date": "End Date",
		"info": "Info",
		"time": "Time",
		"metered": "Metered",
		"non_metered": "Non Metered",
		"connected": "Connected",
		"disconnected": "Disconnected",
		"hello": "Hello",
		"id": "ID",
		"property": "Property",
		"value": "Value",
		"old": "Old",
		"new": "New",
		"public": "Public",
		"private": "Private",
		"required": "Required",
		"extra_info": "Extra Info",
		"get_by": "Get By",
		"date": "Date",
		"result": "Result",
		"pass": "Pass",
		"fail": "Fail",
		"reason": "Reason",
		"history": "History",
		"status": "Status",
		"finish": "Finish",
		"days_value": "day(s)",
		"months_value": "month(s)",
		"years_value": "year(s)",
		"expired": "Expired",
		"view": "View",
		"confirm_action": "Confirm Action",
		"close": "Close",
		"download": "Download",
		"file_name": "File Name",
		"export_csv": "Export To CSV",
		"device(s)": "Device(s)",
		"or": "Or",
		"or_capital": "OR",
		"remove": "Remove",
		"no_selected_files": "No Selected Files!",
		"invalid_csv_file_extension": "File must has valid file extension (.csv)",
		"no_devices_found": "No devices found",
		"no_data_found": "No data found",
		"field_is_required": "Field is required",
		"no_field_changed": "Your submission did not include any changes. Please modify the form before submitting.",
		"all": "All",
		"false": "False",
		"true": "True",
		"confirm": "Confirm",
		"enable": "Enable",
		"disable": "Disable",
		"errors": "Errors",
		"not_applicable": "N/A",
		"filters": "Filters",
		"":""
	},
	"users": {
		"email_is_already_in_use": "Email is already in use",
		"new_password_cannot_be_the_same_as_the_old_password": "New password cannot be the same as the old password",
		"new_password_and_confirm_password_do_not_match": "New password and confirm password do not match",
		"user_not_found": "User not found",
		"old_password_is_incorrect": "Old password is incorrect",
		"user_updated_successfully": "User updated successfully",
		"password_changed_successfully": "Password Changed Successfully",
		"access_functions_updated_successfully": "Access Functions Updated Successfully",
		"user_deleted_successfully": "User deleted successfully",
		"first_name": "First Name",
		"last_name": "Last Name",
		"email": "Email",
		"add_user": "Add User",
		"password": "Password",
		"confirm_password": "Confirm Password",
		"id": "ID",
		"domain": "Domain",
		"successfully_logged_out": "Successfully logged out",
		"sign_in": "Sign In",
		"forgot_password": "Forgot Password?",
		"enter_credentials": "Enter your credentials to continue",
		"user_settings": "User Settings",
		"change_password": "Change Password",
		"logout": "Logout",
		"login": "Login",
		"enable_full_access": "Enable Full Access",
		"forgot_your_password": "Forgot your password?",
		"send_reset_password_link": "Enter your account email address below and we will send you a reset password link",
		"email_address": "Email Address",
		"edit_user": "Edit User",
		"invalid_email_or_password": "Invalid email or password",
		"create_by": "Created By",
		"reset_password": "Reset Password",
		"new_password": "New Password",
		"forgot_email_sent_successfully": "Your reset password email has been sent. if your email is registered",
		"vms_pro_password_reset_email_title": "VMS-PRO Password Reset!",
		"invalid_reset_password_link": "Password Reset link has expired",
		"new_confirm_password_not_mach": "Passwords do not match. Please re-enter.",
		"user_name": "User Name",
		"user_role": "Role",
		"delete_user_confirm_msg": "Are you sure you want to delete this user? This action cannot be undone.",
		"delete_user": "Delete User",
		"change_user_password": "Change User Password",
		"passwords_not_match": "Passwords do not match",
		"no_changes_applied": "No changes were applied",
		"time_zone": "Time Zone",
		"two_sv_enabled": "Enable 2-Step Verification via Email",
		"deleted_user": "Deleted User",
		"": ""
	},
	"devices": {
		"cycle_states": {
			"idle": "Idle",
			"charge": "Charge",
			"cooling_down": "Cooling Down",
			"cooldown_done": "Cooldown Done"	
		},
		"roaming_statuses": {
			"local": "Local",
			"roaming": "Roaming"
		},
   		"access_tech": {
			"gsm": "GSM",
			"umts": "UMTS",
			"gsm_umts_automatic": "GSM_UMTS (Automatic)",
			"gsm_umts_gsm_prefer": "GSM_UMTS (GSM prefer)",
			"gsm_umts_umts_prefer": "GSM_UMTS (UMTS prefer)",
			"lte": "LTE",
			"gsm_lte_automatic": "GSM_LTE (Automatic)",
			"gsm_lte_gsm_prefer": "GSM_LTE (GSM prefer)",
			"gsm_lte_lte_prefer": "GSM_LTE (LTE prefer)",
			"umts_lte_automatic": "UMTS_LTE (Automatic)",
			"umts_lte_umts_prefer": "UMTS_LTE (UMTS prefer)",
			"umts_lte_lte_prefer": "UMTS_LTE (LTE prefer)",
			"gsm_umts_lte_automatic": "GSM_UMTS_LTE (Automatic)",
			"gsm_umts_lte_gsm_prefer": "GSM_UMTS_LTE (GSM prefer)",
			"gsm_umts_lte_umts_prefer": "GSM_UMTS_LTE (UMTS prefer)",
			"gsm_umts_lte_lte_prefer": "GSM_UMTS_LTE (LTE prefer)",
			"gsm_lte_dual_link": "GSM_LTE (Dual-link)",
			"umts_lte_dual_link": "UMTS_LTE (Dual-link)",
			"gsm_umts_lte_dual_link": "GSM_UMTS_LTE (Dual-link)",
			"catm_bg95": "CATM (BG95)",
			"gsm_catm_bg95": "GSM_CATM (GSM prefer, BG95)",
			"catnb_bg95": "CATNB (BG95)",
			"gsm_catnb_bg95_bc32": "GSM_CATNB (GSM prefer, BG95/BC32)",
			"catm_catnb_bg95": "CATM_CATNB (CATM prefer, BG95)",
			"gsm_catm_catnb_bg95": "GSM_CATM_CATNB (GSM prefer, BG95)",
			"catm_gsm_bg95": "CATM_GSM (CATM prefer, BG95)",
			"catnb_gsm_bg95_bc32": "CATNB_GSM (CATNB prefer, BG95/BC32)",
			"catnb_catm_bg95": "CATNB_CATM (CATNB prefer, BG95)",
			"gsm_catnb_catm_bg95": "GSM_CATNB_CATM (GSM prefer, BG95)",
			"catm_gsm_catnb_bg95": "CATM_GSM_CATNB (CATM prefer, BG95)",
			"catm_catnb_gsm_bg95": "CATM_CATNB_GSM (CATM prefer, BG95)",
			"catnb_gsm_catm_bg95": "CATNB_GSM_CATM (CATNB prefer, BG95)",
			"catnb_catm_gsm_bg95": "CATNB_CATM_GSM (CATNB prefer, BG95)",
			"catnb_gsm_enterprise_bc32": "CATNB_GSM (Enterprise, BC32)"
		},
		"rat_keys": {
			"gsm": "GSM",
			"gsm_compact": "GSM COMPACT",
			"utran": "UTRAN",
			"gsm_wegprs": "GSM with EGPRS",
			"utran_whsdpa": "UTRAN with HSDPA",
			"utran_whsupa": "UTRAN with HSUPA",
			"utran_whsdpa_hsupa": "UTRAN with HSDPA and HSUPA",
			"e_utran": "E_UTRAN",
			"utran_hspap": "UTRAN HSPAP",
			"e_utran_ca": "E_UTRAN with Carrier Aggregation",
			"e_utran_nbiot": "E_UTRAN NB-IoT",
			"e_utran_emtc": "E_UTRAN eMTC",
			"none": "None"
		},
		"device_stages": {
			"cm": "CM",
			"sct_inventory": "SCT Inventory",
			"bwt": "BWT",
			"demo_and_engineering": "Demos and Engineering"
		},
		"settings": "Settings",
		"device_not_found": "Device not found",
		"device_is_already_exists": "Device is already exists",
		"imei_is_already_exists": "IMEI is already exists",
		"device_should_be_in_cm_stage": "Device should be in CM stage",
		"device_added_successfully": "Device Added Successfully",
		"device_updated_successfully": "Device Updated Successfully",
		"testing_done_successfully": "Testing Done Successfully",
		"imei": "IMEI",
		"ip_address": "IP Address",
		"po_number": "PO Number",
		"fw_version": "FW Version",
		"hw_version": "HW Version",
		"estimated_latitude": "Estimated Latitude",
		"estimated_longitude": "Estimated Longitude",
		"latitude": "Latitude",
		"longitude": "Longitude",
		"events_end": "Events End",
		"events_start": "Events Start",
		"installation_date": "Installation Date",
		"memory_signature": "Memory Signature",
		"add_device": "Add Device",
		"select_category_or_search": "Select a category or search to load devices.",
		"edit_device": "Edit Device",
		"device_settings": "Device Settings",
		"password": "Password",
		"last_save_time": "Last Save Time",
		"last_save_time_formatted": "Last Save Time",
		"apn": "APN",
		"bands_enabled": "Bands Enabled",
		"gnss_fast_connect": "GNSS Fast Connect",
		"reconnect_time_gps": "Reconnect Time (GPS)",
		"gps_change_distance": "GPS Change Distance",
		"reconnect_time": "Reconnect Time",
		"shipment_quality_result": "Passed Shipment Quality?",
		"remote_server_ip": "Remote Server IP",
		"remote_server_port": "Remote Server Port",
		"num_cells_override": "Number of Cells Override",
		"vcal_drift": "VCAL Drift",
		"vcal_scale": "VCAL Scale",
		"charge_done_voltage": "Charge Done Voltage",
		"charge_detect_voltage": "Charge Detect Voltage",
		"charge_done_time": "Charge Done Time",
		"charge_detect_time": "Charge Detect Time",
		"cooldown_time": "Cooldown Time",
		"inuse_detect_voltage": "In-Use Detect Voltage",
		"charge_to_inuse_time": "Charge to In-Use Time",
		"cooldown_to_inuse_time": "Cooldown to In-Use Time",
		"version": "Version",
		"sequence": "Sequence",
		"mem_sig": "Memory Signature",
		"device_page": "Device Page",
		"device_details": "Device Details",
		"cell_rssi": "Cell RSSI",
		"voltage": "Voltage",
		"cycle_state": "Cycle State",
		"el_level": "Water Level",
		"events": "Events",
		"define": "Define Data",
		"define_version": "Define Version",
		"web_session_parity": "Web Session Parity",
		"start_event_id": "Start Event ID",
		"end_event_id": "End Event ID",
		"start_debug_id": "Start Debug ID",
		"end_debug_id": "End Debug ID",
		"restart_count": "Restart Counter",
		"restart_counter": "Restart Count",
		"restart_count_history": "Restart Count History",
		"previous_count": "Previous Count",
		"event": "Event",
		"trigger": "Trigger",
		"restart_count_events": {
			"device_restart": "Device Restart",
			"counter_cleared": "Counter Cleared"
		},
		"restart_count_triggers": {
			"manual_command": "Manual Command",
			"system": "System",
			"shipping": "Shipping Out"
		},
		"restart_count_report": "Device Restart Count Report",
		"search_mode": "Search Mode",
		"gnss_off_devices": "gnss-off Devices",
		"restart_count_range": "Restart Count range",
		"restart_count_from": "Restart Count From",
		"restart_count_to": "Restart Count To",
		"last_restart_time": "Last Restart Time",
		"current_restart_count": "Current Restart Count",
		"site": "Site",
		"get": "Get",
		"gnss_off": "GNSS Disabled",
		"warnings": "Warnings",
		"voltage_adc": "Voltage ADC",
		"system_info_hash": "System Info Hash",
		"cell_info_hash": "Cell Info Hash",
		"system_info": "System Info",
		"system_name": "System name",
		"system_family_name": "System Family Name",
		"system_version": "System Version",
		"machine": "Machine",
		"short_name": "uPython short name",
		"device_serial_number": "Device Serial Number",
		"modem_fw_version": "Modem Firmware Version",
		"modem_manufacturer": "Modem Manufacturer",
		"crc": "Hash String",
		"iccid": "ICCID",
		"sim_imsi": "SIM IMSI",
		"sct_fw_version": "SCT Firmware Version",
		"fw": "Firmware",
		"v": "Version",
		"passed_shipment_quality": "Passed Shipment Quality",
		"reply_command_version": "Reply Command Version",
		"cell_info": "Cellular Info",
		"type": "Network Type",
		"cell_id": "Cell ID",
		"mobile_country_code": "Mobile Country Code (MCC)",
		"mobile_network_code": "Mobile Network Code (MNC)",
		"location_area_code": "Location Area Code (LAC)",
		"absolute_radio_frequency_channel_number": "Absolute Radio Frequency Channel Number",
		"base_station_identification_code": "Base Station ID (BSIC)",
		"primary_scrambling_code": "Primary Scrambling Code (PSC)",
		"physical_layer_cell_identity": "Physical Cell ID (PCI)",
		"tracking_area_code": "Tracking Area Code (TAC)",
		"ura_id": "URA ID (LCID)",
		"config_access_technology": "Config Access technology",
		"signal_strength_indicator": "Signal Strength (RSSI)",
		"reference_signal_receiving_power": "Reference Signal Power (RSRP)",
		"reference_signal_receiving_quality": "Reference Signal Quality (RSRQ)",
		"channel_quality_indication": "Channel Quality Indicator (CQI)",
		"signal_to_interference_plus_noise_ratio": "Signal-to-Noise Ratio (SNR)",
		"operator_full_name": "Operator Name (Full)",
		"operator_name_abbreviation": "Operator Name (Abbreviated)",
		"roaming_code": "Roaming Status",
		"rat": "Radio Access Technology (RAT)",
		"ip": "Device IP Address",
		"hash": "Data Hash",
		"sih": "System Info Hash",
		"build_date": "Build Date",
		"last_connection_time": "Last Connection Time",
		"restart_device": "Restart Device",
		"command_was_queued": "Command was queued and will be applied once the unit is Online",
		"done_device_delete": "Device Deleted Successfully",
		"done_order_delete": "Order Deleted Successfully",
		"notes": "Device Notes",
		"done_push_fw": "Firmware pushed successfully",
		"debug_records": "Debug Records",
		"record_id": "Record ID",
		"connectivity_track": "Connectivity Track",
		"config_track": "Config Track",
		"last_connect_time": "Last Connect Time",
		"log_time": "Log Time",
		"connection_type": "Connection Type",
		"move_to": "Move to",
		"device_moved_successfully": "Device moved successfully",
		"done_device_system_info_refetch": "Device system info refetched successfully",
		"done_device_cell_info_refetch": "Device system cell refetched successfully",
		"remaining_warranty_period": "Remaining Warranty Period",
		"insertion_time": "Insertion Time",
		"rejection_connected_reason": "Rejection Reason",
		"device_deleted_successfully": "Device Deleted Successfully",
		"exist_fw": "This Device Already Has This Firmware",
		"wrong_number_of_records_in_config_track_compare": "Please select 2 - 10 records to compare",
		"total_charger_cycles": "Total Charge Cycles",
		"device_temperature": "Device Temperature (°F)",
		"firmware_version": "Firmware Version",
		"devices_category": "Device Category",
		"device_should_be_in_demo_engineering_stage": "Device should be in DEMO and Engineering stage",
		"network_mode": "Network Type",
		"volt_samples": "Voltage Samples",
		"temperature_sensor_enable": "Temperature Sensor Enable",
		"enable_state_change_log": "Enable State Change Log",
		"volt_samples_period": "Voltage Sampling Period",
		"el_sampling_period": "El Sampling Period",
		"last_update_location_time": "Location Acquire Time",
		"last_gps_lock": "Location Acquire Time",
		"queued_changes": "Queued Changes",
		"queued_value": "Queued Value",
		"changed_by": "Changed By",
		"queued_at": "Queued At",
		"serial_number": "Serial Number",
		"sn_already_exist": "Serial number already exist",
		"sim_auth_missing": "SIM_AUTH env variable is missing",
		"num_of_cells": "Battery Number of Cells",
		"": ""
	},
	"cellular_rssi_values": {
		"zero_cellular_rssi": "0 -113 dBm or less",
		"one_cellular_rssi": "-111 dBm",
		"mid_cellular_rssi": "-51 dBm or greater",
		"unknown_cellular_rssi": "Unknown RSSI with a value of: {{cellular_rssi}}",
		"cellular_rssi_unknown_or_undetectable": "Unknown or undetectable",
		"invalid_cellular_rssi": "Invalid RSSI value",
		"": ""
	},
	"cycle_state_values": {
		"idle": "Idle",
		"charge": "Charge",
		"cooling_down": "Cooling Down",
		"cooldown_done": "Cooldown Done",
		"": ""
	},
	"schedules": {
		"schedules_updated_successfully": "Schedules Updated Successfully",
		"scheduled_successfully": "Scheduled Successfully",
		"": ""
	},
	"validation": {	
		"is_required": "is required",
		"invalid_email": "Invalid email format",	
		"passwords_not_match": "Passwords do not match",
		"invalid_format": "Invalid format",
		"hw_version_not_match": "HW version must be shorter than or equal to 2 characters",
		"invalid_serial_number": "Invalid serial number format",
		"": ""
	},
	"nav": {
		"users": "Users",
		"home": "Home",
		"devices": "Devices",
		"devices_list": "Devices List",
		"users_list": "Users List",
		"add_device": "Add Device",
		"add_user": "Create User",
		"edit_device": "Edit Device",
		"access_functions": "Access Functions",
		"users_management": "Users Management",
		"devices_management": "Devices Management",
		"admin_tools": "Admin Tools",
		"api_logs": "API Logs",
		"fw_logs": "Firmware Logs",
		"fw_upload": "Upload Firmware",
		"action_log": "Action Log",
		"reject_device_connections_logs": "Rejected Device Connections",
		"device_restart_count_report": "Device Restart Count Report",
		"shipment":	 "Shipment Management",
		"receive_shipment": "Receive Shipment",
		"shipment_quality": "Shipment Quality",
		"receive_shipment_history": "Receive Shipment History",
		"shipment_quality_history": "Shipment Quality History",
		"shipping_out": "Shipping Out",
		"shipping_out_history": "Shipping Out History",
		"orders_management": "Orders Management",
		"create_order": "Create Order",
		"view_order": "View Order",
		"edit_order": "Edit Order",
		"firmware_update": "Firmware Update",
		"fw_update_history_per_device_category": "Firmware Update History",
		"user_role": "User Roles",
		"cm_fw_versions": "CM FW Versions",
		"schedule_run": "Schedule Run",
		"": ""
	},
	"tooltip": {
		"volt_samples": "This field is supported by devices with FW v0.2.2 and up",
		"volt_samples_period": "This field is supported by devices with FW v0.2.2 and up",
		"el_sampling_period": "This field is supported by devices with FW v0.2.2 and up",
		"temperature_sensor_enable": "This field is supported by devices with FW v0.1.5 and up",
		"enable_state_change_log": "This field is supported by devices with FW v1.1.3 and up",
		"": ""
	},
	"api_logs": {
		"end_point": "End Point",
		"body_request": "Body Request",
		"query_request": "Query Request",
		"created_at": "Action time",
		"user_id": "User ID",
		"request_params": "Request Parameters",
		"": ""
	},
	"access_func": {
		"cm": "CM",
		"admin": "Admin",
		"super_admin": "Super Admin",
		"client": "Client",
		"demo": "Demo",
		"management_function":	"Management Function",
		"edit_user_access_functions": "Edit User Access Functions",
		"access_functions_documentation": "Access Functions Documentation",
		"role_name": "Role Name",
		"done_by": "Done By",
		"create_user_role": "Create User Role",
		"all_access_function": "All Access Functions",
		"role_access_function": "Role Access Functions",
		"web_user": "Web User",
		"temperature_report": "Temperature Report",
		"add_device": "Add Device",
		"access_all_devices": "Access All Devices",
		"device_management": "Device Management",
		"users_management": "Users Management",
		"debug_data": "Debug Data",
		"sched_management": "Schedule Management",
		"access_rejection_logs": "Access Rejection Logs",
		"access_action_logs": "Access Action Logs",
		"reset_device_data": "Reset Device Data",
		"shipment_management": "Shipment Management",
		"fw_management": "Firmware Management",
		"apis_logs": "APIs Logs",
		"orders_management": "Orders Management",
		"": ""
	},
	"roles": {
		"name": "Role Name",
		"user_list": "user list",
		"user_create": "create user",
		"user_edit": "user edit",
		"user_access_functions": "user access function",
		"api_logs": "API Logs",
		"fw_upload": "Upload Firmware",
		"fw_logs": "Firmware Logs",
		"action_log": "Action Log",
		"device_list": "device list",
		"device_create": "create device",
		"device_settings": "Device Settings",
		"device_events": "device events",
		"device_define": "device define",
		"system_info": "System Info",
		"cell_info": "Cellular Info",
		"debug_records": "Debug Records",
		"connectivity_track": "Connectivity Track",
		"config_track": "Config Track",
		"device_page": "Device Page",
		"dashboard": "dashboard",
		"search_device_details": "search device details",
		"device_notes": "device notes",
		"rejection_devices_logs": "Rejection device logs",
		"receive_shipment": "Receive Shipment",
		"shipment_quality": "Shipment Quality",
		"receive_shipment_history": "Receive Shipment History",
		"shipment_quality_history": "Shipment Quality History",
		"shipping_out": "Shipping Out",
		"shipping_out_history": "Shipping Out History",
		"receive_shipment_results": "receive shipment results",
		"shipment_quality_results": "shipment quality results",
		"cellular_info_track": "cellular info track",
		"orders_management": "Orders Management",
		"create_order": "Create Order",
		"view_order": "View Order",
		"edit_order": "Edit Order",
		"firmware_update": "Firmware Update",
		"user_roles": "user roles",
		"duplicate_role_name": "Role name already exist",
		"super_admin": "Super Admin",
		"management_function": "Management Function",
		"client": "Client",
		"cm": "CM",
		"web_user": "Web User",
		"temperature_report": "Temperature Report",
		"add_device": "Add Device",
		"access_all_devices": "Access All Devices",
		"device_management": "Device Management",
		"users_management": "Users Management",
		"debug_data": "Debug Data",
		"sched_management": "Schedule Management",
		"access_rejection_logs": "Access Rejection Logs",
		"access_action_logs": "Access Action Logs",
		"reset_device_data": "Reset Device Data",
		"shipment_management": "Shipment Management",
		"fw_management": "Firmware Management",
		"apis_logs": "APIs Logs",
		"": ""
	},
	"events": {
		"event_id": "Event ID",
		"event_time": "Event Time",
		"charge_cycles": "Charge Cycles",
		"inuse_cycles": "Inuse Cycles",
		"cooldowns": "Cooldowns",
		"watered": "Watered",
		"el_level": "Water Level",
		"water_low_days": "Water Low Days",
		"events": "Events",	
		"min_temperature": "Min Temperature (°F)",
		"max_temperature": "Max Temperature (°F)",
		"min_voltage": "Min Voltage",
		"max_voltage": "Max Voltage",
		"bad_temp_report": "Bad Temperature Report",
		"min_temperature_report": "Min Temperature (C)",
		"max_temperature_report": "Max Temperature (C)",
		"system_start_request": "System Start Request",
		"got_fw_update": "Firmware Update received",
		"first_event_after_restart": "First Event After Restart",
		"scheduler_restart": "Scheduler Restart",
		"": ""
	},
	"settings": {
		"apply_changes": "Apply Changes",
		"queue_it": "Queue It",
		"queue_and_wait": "Queue and Wait",
		"save_device_settings": "Save Device Settings",
		"changes_queued": "Change has been queued and will be executed and the device will be restarted when the device is connected",
		"": ""	
	},
	"actions": {
		"restart_device": "Restart Device",
		"exit_main_debug_device": "Exit Main Debug Device",
		"exit_main_debug_device_message": "Are you sure you want to exit the main debug mode of this device?",
		"delete_device": "Delete Device",
		"reset_device_data": "Reset Device Data",
		"delete_device_message": "Are you sure you want to delete this device?",
		"reset_device_data_message": "Are you sure you want to reset this device data?",
		"restart_device_message": "Are you sure you want to restart this device?",
		"push_fw_message": "Choose the firmware version you want to push to the device.",
		"move_to_stage": "Moving Device",
		"move_to_stage_message": "Are you sure you want to move this device to {{stage}}?",
		"fetch_system_info": "Fetch System Info",
		"fetch_system_info_message": "Are you sure you want to refetch system info from this device?",
		"fetch_cell_info": "Fetch Cell Info",
		"fetch_cell_info_message": "Are you sure you want to refetch cell info from this device?",
		"clear_restart_counter": "Clear Restart Counter",
		"clear_restart_counter_message": "Are you sure you want to clear the restart count for this device?",
		"": ""
	},
	"fw": {
		"exists_version": "Exists Version List",
		"upload_new_version": "Upload New Version",
		"cell": "cell.py",
		"commands": "commands.py",
		"common": "common.py",
		"config": "config.py",
		"cycle_detect": "cycleDetect.py",
		"events": "events.py",
		"exception": "exception.py",
		"fota_download": "fota_download.py",
		"led": "led.py",
		"main": "main.py",
		"micro_py_gps": "MicroPyGPS.py",
		"readings": "readings.py",
		"file_name_error": "File name should be: {{fileName}}",
		"file_size_error": "File size should be less than {{maxSize}} MB",
		"required_files_missing": "Missing required files. Required files: {{messageData}}",
		"version_exists": "Version {{version}} already exists",
		"version_exists_backend": "Version {{messageData}} already exists",
		"no_files_provided": "No files provided",
		"missing_required_files": "Missing required files. Required files: {{messageData}}",
		"version_name_required": "Version name is required",
		"not_valid_version_name": "Not valid version name",
		"files_exceeded_max_size": "Files exceeded max size. Exceeded files: {{messageData}}",
		"delete_version_title": "Delete Version",
		"delete_version_text": "Are you sure you want to delete version {{version}}?",
		"push_fw": "Push Firmware",
		"select_version": "Select Version",
		"file_name": "File Name",
		"file_size": "File Size",
		"no_files": "No Files In This Version",
		"upload_files": "Upload Files",
		"confirm_push_fw_all_devices_meg": "Are you sure you want to push firmware version",
		"update_firmware_log": "Update Firmware Log",
		"blocked_firmware_report": "Blocked Firmware Report",
		"old_version": "Old Version",
		"new_version": "New Version",
		"fw_version": "Firmware Version",
		"update_time": "Update Time",
		"blocked_until": "Blocked Until",
		"block_reason": "Block Reason",
		"unblock": "Unblock",
		"unblock_title": "Are you sure you want to unblock firmware update from this device(s)?",
		"fw_progress": "Progress",
		"fw_history_devices": "Fw History Devices",
		"in_progress": "In Progress",
		"completed": "Completed",
		"": ""
	},
	"notes": {
		"note": "Note",
		"added_by": "Added By",
		"shared_with": "Shared With",
		"add_note": "Add Note",
		"note_date": "Time Added",
		"edit_note_visibility": "Edit Visibility",
		"confirm_delete_note": "Delete Device Note Confirmation",
		"delete_message_note_confirm": "Are you sure you want to delete the device note?",
		"device_note_deleted": "Device note deleted",
		"update_device_note": "Update Note",
		"device_note_not_exist": "Device Note Not Exist",
		"export_file_device_notes": "Device Notes {{imei}}",
		"": ""
	},
	"client_socket_type": {
		"0": "WiFi",
		"1": "Ethernet",
		"2": "Cellular",
		"": ""
	},
	"config": {
		"show_configs": "Show Configs",
		"configs": "Configs",
		"configurations": "Configurations",
		"compare_configurations": "Compare Configurations",
		"changes_track": "Changes Track",
		"cellular_track": "Cellular Track",
		"system_info_track": "System Info Track",
		"select_between_2_10": "Please select 2 - 10 records to compare",
		"": ""
	},
	"rejection_connection_logs": {
		"device_not_found": "Device not found",
		"huge_queue_size": "Huge queue size",
		"rejection_reason": "Rejection Reason",
		"delete_device_rejection_log_confirm": "Delete Device Rejection Log Confirmation",
		"confirm_delete_log_mesg": "Are you sure you want to delete the device rejection log?",
		"device_rejection_log_deleted": "Device Rejection Log Deleted",
		"selected_rejection_log_not_exist": "Selected device rejection log not exist",
		"":""
	},
	"shipment": {
		"user_name": "User Name",
		"cm_po_number": "CM PO Number",
		"success_no_devices": "Number of successfully received devices",
		"success_checked_no_devices": "Number of successfully checked devices",
		"total_no_devices": "Total number of devices",
		"checked_quantity": "Checked Quantity?",
		"received_successfully": "Received Successfully",
		"checked_successfully": "Checked Successfully",
		"in_progress": "In Progress",
		"not_connected": "Not connected",
		"cellular_not_connected": "Cellular Not Connected",
		"not_reachable": "Device Is Unreachable",
		"warnings": "Warnings",
		"fw_request": "FW Update Request",
		"factory_reset": "Factory Reset Error",
		"completed": "Completed",
		"no_cellular_iccid": "No Cellular ICCID",
		"cellular_iccid_does_not_exist": "Cellular ICCID Does Not Exists",
		"not_authorized": "Not Authorized",
		"device_not_cm_devices": "The device is not in CM devices",
		"completed_gps_not_ready": "Completed, GPS not ready",
		"gps_not_ready": "GPS is not ready",
		"fw_update_prevented": "Waiting device to connect to Wi-Fi",
		"voltage_error": "The voltage must be within 20V and 95V",
		"current_error": "The current must be within -10A and 10A",
		"not_cm_devices": "The device is not in CM devices",
		"move_to_bulk": "Move to Bulk",
		"check_all_shipment": "Check All Shipment",
		"not_in_cm": "Device is not in CM devices",
		"not_in_inventory": "Device is not in SCT Inventory",
		"device_is_disconnected": "Device is disconnected",
		"invalid_voltage": "Device voltage must be 20V or higher",
		"invalid_water_level": "Water level must be high",
		"invalid_temperature": "Temperature must be between 20°C and 35°C",
		"failed_reason": "Failed Reason",
		"working_on": "Working on",
		"failed_devices": "Failed Devices",
		"passed_devices": "Passed Devices",
		"check_all_failed": "Check all failed",
		"csv_file_rules_shipment_quality_msg": "File extension must be CSV with maximum of 1500 devices",
		"import_shipment_quality_devices_csv": "Check if devices passed and is under CM processing",
		"import_devices_csv": "Import Devices CSV",
		"invalid_file_length": "No added devices in the file",
		"shipment_quality_csv_file_more_1500_records": "Failed to import CSV because it contains more than 1500 devices",
		"csv_file_more_50_records": "Failed to import CSV because it contains more than 50 devices",
		"passed_shipment_quality": "Passed",
		"not_passed_shipment_quality": "Device didn’t pass shipment quality",
		"not_tested": "Not Tested",
		"passed": "Passed",
		"failed": "Failed",
		"receive_all_failed": "Receive All Failed",
		"receive_devices": "Receive Devices",
		"receive_devices_that_didnt_pass_shipment_quality": "Receive devices that didn’t pass shipment quality",
		"the_device_didnt_pass_shipment_quality": "The device didn’t pass shipment quality",
		"csv_file_rules_msg": "File extension must be CSV with maximum of 50 devices",
		"field_import_csv_devices_not_found": "Failed to import CSV because the following devices do not exist on the system",
		"device_already_in_bulk": "Device already in bulk",
		"no_cm_po_number": "No CM PO Number",
		"receive_shipment_note": "Device moved to SCT Inventory through receive shipment by {{userFullName}}",
		"shipping_date": "Shipping Date",
		"attachments": "Attachments",
		"shipped_devices": "Shipped Devices",
		"fail_reason": "Fail Reason",
		"ship_to": "Ship to",
		"select_po_number": "Select a PO First",
		"reached_order_limit": "Reached order limit of devices",
		"shipped_to": "Shipped to",
		"select_ship_to": "Select Ship to",
		"devices_exceeded_po_remaining": "Failed to import CSV because it contains more devices than remaining in PO",
		"no_devices_to_ship": "No Devices to Ship",
		"shipping_out_note": "Device is moved to {{stage}} device category through shipping out process by {{userFullName}}",
		"wrong_order_status": "Wrong Order Status",
		"": ""
	},
	"order": {
		"order_number": "Order Number",
		"receiver_name": "Receiver Name",
		"unshipped": "Unshipped",
		"shipped": "Shipped",
		"purchase_order": "Purchase Order",
		"create_time": "Create Time",
		"shipping_time": "Shipping Date",
		"devices": "Ordered VMS Devices",
		"shipped_devices": "Shipped VMS Devices",
		"attachments": "Attachments",
		"add_shipping_information": "Add Shipping Information",
		"delete_new_order_message": "Are you sure you want to delete PO {{po_number}} ?",
		"tracking_number": "Tracking Number",
		"shipping_company": "Shipping Company",
		"shipping_date": "Shipping Date",
		"add_shipping_information_title": "Order {{po_number}} Shipping Information",
		"order_attachment": "Order Attachments",
		"shipment_attachments": "Shipments Attachments",
		"order": "Order",
		"new": "New",
		"in_process": "In Process",
		"ready_to_ship": "Ready to Ship",
		"scv_file_shipped": "Shipped Orders list",
		"scv_file_unshipped": "Unshipped Orders list",
		"receiver_company_name": "Receiver Company Name",
		"remaining": "{{remainingDevicesCount}} device(s) remaining",
		"done_delete_order": "The order was deleted successfully.",
		"unshipped_order_list": "Unshipped Orders list",
		"shipped_order_list": "Shipped Orders list",
		"remove_order_attachment_subject": "An attachment has been removed from order",
		"add_order_new_attachment_subject": "A new attachment has been added to order",
		"": ""
	},
	"order_form": {
		"po_number": "PO Number",
		"devices_count": "Number Of VMS Devices",
		"receiver_address": "Receiver Address",
		"receiver_name": "Name",
		"receiver_company_name": "Company Name",
		"receiver_company_email": "Company Email",
		"receiver_first_address_line": "Address Line 1",
		"receiver_second_address_line": "Address Line 2",
		"receiver_zip_code": "Zip Code",
		"receiver_city": "City",
		"receiver_country": "Country",
		"receiver_phone_number": "Phone No",
		"receiver_phone_number_extension": "Phone No. Extension",
		"receiver_email": "Email",
		"notifications_emails": "Notifications Emails",
		"notifications_email_list": "Email Addresses",
		"status": "Status",
		"shipping_information": "Shipping Information",
		"shipping_company": "Shipping Company",
		"shipping_date": "Shipping Date",
		"shipping_tracking_number": "Shipping Tracking Number",
		"no_order_provided": "No Order Provided",
		"wrong_emails_list": "Wrong Emails List",
		"duplicate_po_number": "PO Number Already Exist",
		"no_changes": "No Changes",
		"invalid_order": "Invalid Order",
		"devices_count_less_than_shipped": "Cannot decrease the order devices count less than quantity of shipped devices",
		"shipment_tracking_number": "Tracking Number",
		"": ""
	},
	"order_emails": {
		"new_order_created_email_title": "Order {{poNumber}} has been created",
		"order_created_email_subject": "{{firstName}} {{lastName}} created a new order",
		"order_edited_email_title": "{{firstName}} {{lastName}} made the following changes to order",
		"order_edited_email_subject": "Order {{poNumber}} has been edited",
		"order_added_email_subject": "You have been added to order {{poNumber}} notification list",
		"order_added_email_title": "You have been added to the notifications list for the order below:",
		"order_shipped": "Order {{poNumber}} has been Shipped",
		"order_shipped_title": "has been shipped. Tracking number was added by {{firstName}} {{lastName}}",
		"delete_order_email_subject": "Order {{poNumber}} has been deleted",
		"delete_order_email_title": "{{firstName}} {{lastName}} deleted order",
		"receiver_name": "Receiver Name",
		"receiver_company_name": "Receiver Company Name",
		"receiver_company_email": "Receiver Company Email",
		"receiver_first_address_line": "Receiver Address Line 1",
		"receiver_second_address_line": "Receiver Address Line 2",
		"receiver_zip_code": "Receiver Zip Code",
		"receiver_city": "Receiver City",
		"receiver_country": "Receiver Country",
		"receiver_phone_number": "Receiver Phone No",
		"receiver_phone_number_extension": "Phone No. Extension",
		"receiver_email": "Receiver Email",
		"po_number": "Order number",
		"devices_count": "Ordered items",
		"shipping_company": "Shipping Company",
		"shipment_tracking_number": "Tracking Number",
		"shipping_date": "Shipping Date",
		"notifications_email_list": "Notifications Email List",
		"": ""
	},
	"attachments": {
		"attachments": "Attachments",
		"files_min_count_err": "The min selected files count is 1 file",
		"files_max_count_err": "The selected files count exceeded the allowed max count",
		"extension_err": "The file type is not from the allowed types",
		"size_err": "The file size exceeded the allowed max size",
		"note_err": "The note characters exceeded the allowed note max characters",
		"choose_files": "Choose files",
		"no_attachments": "No attachments",
		"shipment_no_attachments": "Shipment {{no}} Attachments",
		"success_attachments": "Successfull Attachments",
		"file_already_attached": "The file is already attached",
		"delete_attachment": "Are you sure you want to delete this attachments?",
		"no_selected_files": "No Selected Files!",
		"": ""
	},
	"action_logs": {
		"action_name": "Action Name",
		"related_id_name": "Related ID - Name",
		"related_id": "Related ID",
		"additional_related_id_name": "Additional ID - Name",
		"additional_related_id": "Additional ID",
		"old_values": "Old Values",
		"new_values": "New Values",
		"action_user_id_name": "Action User ID - Name",
		"action_user_id": "Action User ID",
		"action_time": "Action Time",
		"ip_address": "IP Address",
		"user_agent": "User Agent",
		"git_info": "Git Info",
		"log_month": "Log Month",
		"generic_id_search": "Generic ID Search",
		"update_device": "Update Device",
		"update_device_queued": "Update Device (Queued)",
		"create_device": "Create Device",
		"add_model_notes": "Add Model Notes",
		"update_model_note_visibility": "Update Model Note Visibility",
		"delete_device_note": "Delete Device Note",
		"forgot_password": "Forgot Password",
		"reset_user_password": "Reset User Password",
		"update_fw_devices_category": "Update Devices fw category",
		"move_device": "Move Device",
		"restart_device": "Restart Device",
		"reset_device_data": "Reset Device Data",
		"clear_restart_counter": "Clear Restart Counter",
		"delete_device": "Delete Device",
		"push_device_fw": "Push Device Firmware",
		"receive_device_shipment": "Receive Device Shipment",
		"check_shipment_quality": "Check Shipment Quality",
		"ship_out_device": "Shipped-out device",
		"create_order": "Create Order",
		"edit_order": "Edit Order",
		"update_shipping_info": "Update Shipping Info",
		"user_login": "User Login",
		"add_user": "Add User",
		"edit_user": "Edit User",
		"delete_user": "Delete User",
		"change_user_password": "Change User Password",
		"order_add_attachment": "Order Add Attachment",
		"order_delete_attachment": "Order Delete Attachment",
		"update_cm_fw_versions": "Update CM FW Versions",
		"": ""
	},
	"otp": {
		"your_verification_code": "Your Verification Code",
		"otp_resent": "We've sent a new code to your email. Please use the latest email you received. If it isn't in your inbox, please check your Spam or Junk folder",
		"max_resend_attempts_reached": "Maximum resend attempts reached",
		"otp_expired": "This code has expired. Please request a new one.",
		"max_attempts_reached": "Maximum verification attempts reached for this code",
		"enter_verification_code": "Enter verification code",
		"otp_sent": "We've sent a 6-digit code to your email ({{email}}). It may take a few seconds to arrive. If you don't see it, please check your Spam or Junk folder",
		"max_attempts_reached_message": "You've reached the maximum attempts for this code. Please request a new code to continue.",
		"resend": "Resend",
		"verify": "Verify",
		"request_new_code": "Request New Code",
		"link_expired": "Link Expired!",
		"invalid_otp": "Invalid Verification Code. Please try again.",
		"blocked_login_subject": "Your Account Is blocked Temporary for Security Reasons",
		"login_blocked_try_after_x_minutes": "Login for this account is temporarily blocked due to too many incorrect login attempts. Please try again after {{counter}} minutes",
		"unblock_account_msg": "Your account has been temporarily blocked.",
		"unblock_account_button": "Click the button below to unblock your account.",
		"": ""
	},
	"cm_fw_versions": {
		"module_fw": "Modem Version",
		"sct_fw_version": "SCT FW Version",
		"quecpython_version": "Quecpython Version",
		"": ""
	},
	"warnings": {
		"warning_voltage_adc_low": "Voltage ADC reading lower than acceptable threshold",
		"warning_voltage_adc_high": "Voltage ADC reading higher than acceptable threshold",
		"warning_temperature_adc_low": "Temperature ADC reading lower than acceptable threshold",
		"warning_temperature_adc_high": "Temperature ADC reading higher than acceptable threshold",
		"warning_adc_mux_high_failure": "MUX failed while switching to read Temperature",
		"warning_adc_mux_low_failure": "MUX failed while switching to read Voltage",
		"warning_adc_runtime_failure": "ADC failed during runtime",
		"warning_adc_init_failure": "ADC failed on init",
		"warning_sim_init_failure": "SIM failed on init",
		"": ""
	},
	"legal": {
		"privacy_policy": "Privacy Policy",
		"terms_conditions": "Terms & Conditions"
	}
}